import * as yup from 'yup';
import { phoneRegExp } from '../../../../helpers/regex';

const isNewClientSl = newClientSl => +newClientSl == 1;

export const validations = yup.object().shape({
  newClientSl: yup
    .string()
    .required('Selecione o tipo de cliente SL'),
  name: yup
    .string()
    .when('newClientSl', {
      is: isNewClientSl,
      then: yup.string().required('O nome é obrigatório')
    }),
  phone: yup
    .string()
    .when('newClientSl', {
      is: isNewClientSl,
      then: yup
        .string()
        .required('O telefone é obrigatório')
        .test(function (value) {
          if (!value) {
            return true;
          }

          if (!phoneRegExp?.test(value)) {
            return this.createError({
              message: 'O telefone precisa ser válido',
              path: 'phone'
            });
          }

          return true;
        }),
      otherwise: yup
        .string()
        .test(function (value) {
          if (!value) {
            return true;
          }

          if (!phoneRegExp?.test(value)) {
            return this.createError({
              message: 'O telefone precisa ser válido',
              path: 'phone'
            });
          }

          return true;
        })
    }),
  email: yup
    .string()
    .transform(function(value) {
      return value.trim();
    })
    .email('O e-mail precisa ser válido')
    .required('O e-mail é obrigatório')
});

export const modalValidations = yup.object().shape({
  reason: yup
    .string()
    .required('O motivo é obrigatório'),
  password: yup
    .string()
    .required('A senha é obrigatória'),
  passwordConfirm: yup
    .string()
    .when('password', (password, schema) =>
      password ? schema.required('Confirme a senha') : schema
    )
    .oneOf(
      [yup.ref('password'), null],
      'A senha e a confirmação devem ser iguais'
    ),
  actionConsent: yup
    .boolean()
    .test(function(actionConsent) {
      if(!actionConsent) {
        return this.createError({
          message: 'Você precisa confirmar este campo',
          path: 'actionConsent'
        });
      }

      return true;
    })
});